export const scan = {
  name: "scan" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M2.1 3.002a.9.9 0 0 1 .9-.9h5a.9.9 0 0 1 0 1.8H3.9v4.1a.9.9 0 1 1-1.8 0v-5Zm13 0a.9.9 0 0 1 .9-.9h5a.9.9 0 0 1 .9.9v5a.9.9 0 1 1-1.8 0v-4.1H16a.9.9 0 0 1-.9-.9ZM3 15.102a.9.9 0 0 1 .9.9v4.1H8a.9.9 0 1 1 0 1.8H3a.9.9 0 0 1-.9-.9v-5a.9.9 0 0 1 .9-.9Zm18 0a.9.9 0 0 1 .9.9v5a.9.9 0 0 1-.9.9h-5a.9.9 0 0 1 0-1.8h4.1v-4.1a.9.9 0 0 1 .9-.9Z" clip-rule="evenodd"/><path d="M18 11H6a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2Z"/></svg>`,
  keywords: ["scan"],
  category: "device" as const,
};
